import { useQuery } from '@tanstack/react-query';
import { getImportHistory } from "../orgPanelApiCalls";
import { useStore } from "../appStore"

const key = 'importHistory';

const useGetImportHistoryQuery = () => {
    const orgId = useStore((state) => state.CurrentOrganizationId);

    return useQuery({
        queryKey: [key, orgId], 
        queryFn: () => getImportHistory(orgId) 
    });
}

export { useGetImportHistoryQuery, key };